cdb.config.set('assets_url', '//cartodb-libs.global.ssl.fastly.net/cartodbui/assets/3.23.57');
console.log('cartodbui v3.23.57');